import { render, staticRenderFns } from "./FirmaDetay.vue?vue&type=template&id=00812f5e&scoped=true&"
import script from "./FirmaDetay.vue?vue&type=script&lang=js&"
export * from "./FirmaDetay.vue?vue&type=script&lang=js&"
import style0 from "./FirmaDetay.vue?vue&type=style&index=0&id=00812f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00812f5e",
  null
  
)

export default component.exports